import angular from "angular";
import uiRouter from "angular-ui-router";
import { extendModule } from "ng";

import $appConfig from "servicestack/config";
import $session from "servicestack/session";
import ServiceBus from "servicestack/service-bus";
import AutoQueryConfig from "servicestack/auto-query/auto-query.config";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import {
  AutoQueryFactory,
  AutoQueryDirectiveFactory,
} from "servicestack/auto-query/auto-query.legacy.es6";
import SortOptions from "servicestack/sort-options";
import PageSizes from "servicestack/page-sizes";
import TagFilter from "servicestack/auto-query/auto-query-tag-filter";
import BooleanFilter from "servicestack/auto-query/auto-query-boolean-filter";
import GroupByFilter from "servicestack/auto-query/auto-query-group-by-filter";
import NavPanel from "servicestack/auto-query/auto-query-nav-panel";
import Nav from "servicestack/auto-query/auto-query-nav";
import FilterSelector from "servicestack/auto-query/auto-query-filter-selector";
import SearchPanel from "servicestack/auto-query/auto-query-search-panel";
import TextFilter from "servicestack/auto-query/auto-query-text-filter";
import DateFilter from "servicestack/auto-query/auto-query-date-filter";
import RadioFilter from "servicestack/auto-query/auto-query-radio-filter";
import NumberFilter from "servicestack/auto-query/auto-query-number-filter";
import RefinementsPanel from "servicestack/auto-query/auto-query-refinements-panel";
import RefinementsBar from "servicestack/auto-query/auto-query-refinements-bar";
import Criteria from "servicestack/auto-query/auto-query-criteria";
import Header from "servicestack/auto-query/auto-query-header";
import Footer from "servicestack/auto-query/auto-query-footer";
import Breadcrumbs from "servicestack/auto-query/auto-query-breadcrumbs";
import Headlines from "servicestack/auto-query/auto-query-headlines";
import Views from "servicestack/auto-query/auto-query-views";
import sortableHeaders from "servicestack/sortable-headers";
import sendEmailPrompt from "servicestack/email/send-email-prompt.directive";
import ssUtils from "servicestack/util";
import registerTags from "servicestack/tags/_register";
import registerAutomations from "servicestack/automations/_register";
import registerFileImports from "servicestack/file-import/_register";
import webutils from "webutils/app";
import dataFileModule from "servicestack/data-files/data-file.module";
import ipaFileModule from "servicestack/ipa-files/ipa-file.module";
import appReleasesModule from "servicestack/app-releases/app-releases.module";
import tagNavigatorModule from "servicestack/tags/navigator/tag-navigator.module";
import tagPaginationModule from "servicestack/tags/pagination/tag-pagination.module";
import entityMessagePromptDirective from "servicestack/messaging/entity-message-directive";
import entityNotePromptDirective from "servicestack/notes/entity-note-directive";
// import dataFileContainer from "servicestack/data-files/data-file-container";

//runner
import servicestackGTM from "servicestack/servicestack.gtm";
const RE_SANITIZE =
  /^\s*(https?|blob|data|ss|ftp|mailto|tel|file|sms|itms-services|javascript|chrome-extension):/;

const app = angular
  .module("servicestack", ["ngStorage", "webutils", uiRouter])
  .config(($compileProvider) => {
    $compileProvider.aHrefSanitizationWhitelist(RE_SANITIZE);
    $compileProvider.imgSrcSanitizationWhitelist(RE_SANITIZE);
    // console.debug(
    //   " $compileProvider",
    //   $compileProvider,
    //   angular.version,
    //   $compileProvider.preAssignBindingsEnabled,
    //   $compileProvider.preAssignBindingsEnabled()
    // );
    // $compileProvider.preAssignBindingsEnabled(true);
  })
  .component("autoQueryNavPanel", NavPanel)
  .component("autoQueryFilterSelector", FilterSelector)
  .component("autoQueryTagFilter", TagFilter)
  .component("autoQueryBooleanFilter", BooleanFilter)
  .component("autoQueryGroupByFilter", GroupByFilter)
  .component("autoQuerySearchPanel", SearchPanel)
  .component("autoQueryTextFilter", TextFilter)
  .component("autoQueryDateFilter", DateFilter)
  .component("autoQueryRadioFilter", RadioFilter)
  .component("autoQueryNumberFilter", NumberFilter)
  .component("autoQueryCriteria", Criteria)
  .component("autoQueryLeftNav", Criteria)
  .component("autoQueryRefinementsPanel", RefinementsPanel)
  .component("autoQueryRefinementsBar", RefinementsBar)
  .component("autoQueryFooter", Footer)
  .component("autoQueryHeader", Header)
  .component("autoQueryHeadlines", Headlines)
  .component("autoQueryBreadcrumbs", Breadcrumbs)
  .component("autoQueryNav", Nav)
  .component("autoQueryViews", Views)
  .component("sortOptions", SortOptions)
  .component("pageSizes", PageSizes)
  // .component("albie", dataFileContainer)
  // .component("dataFileContainer", dataFileContainer)
  .directive("sortableHeaders", sortableHeaders)
  .directive("sendEmailPrompt", sendEmailPrompt)
  .value("$appConfig", $appConfig)
  .value("$session", $session)
  .value("ServiceBus", ServiceBus)
  .value("createServiceBus", () => new ServiceBus())
  .value("AutoQuery", AutoQuery)
  .value("createAutoQuery", (options) => new AutoQuery(options))
  .value("ssUtils", ssUtils)
  .factory("AutoQueryLegacy", AutoQueryFactory)
  .directive("autoQuery", AutoQueryDirectiveFactory)
  .directive("entityMessagePrompt", entityMessagePromptDirective)
  .directive("entityNotePrompt", entityNotePromptDirective)
  .run(servicestackGTM)
  .run(($rootScope, $session, $localStorage, $timeout) => {
    $rootScope.$session = $session;
    $rootScope.$appConfig = $appConfig;
    if (AutoQueryConfig.clearUserSettings) {
      const clearUserSettings = (e) => {
        for (let i = 0, len = localStorage.length; i < len; ++i) {
          const k = localStorage.key(i);
          if (k.endsWith(":AQ")) {
            console.debug("deleting:aq", k, localStorage.getItem(k));
            localStorage.removeItem(k);
            delete $localStorage[k];
            $timeout(() => localStorage.removeItem(k), 88); //hack b/c it won't go away
          }
        }
      };
      $rootScope.$on("$onAuthenticated", clearUserSettings);
      $rootScope.$on("$onLogout", clearUserSettings);
    }
  });

registerTags(app);
registerAutomations(app);
registerFileImports(app);
extendModule(
  app,
  dataFileModule,
  ipaFileModule,
  tagNavigatorModule,
  tagPaginationModule,
  appReleasesModule
);

export default app.name;
